// src/components/transfers/printTransfer.js

const STATUS_LABELS = {
  pending: '待确认', shipped: '已发货', received: '已收货',
  payment_pending: '待收款', completed: '已完成', cancelled: '已取消',
};

const LOG_ACTION_MAP = {
  edit_quantity: '修改数量', add_item: '新增商品', remove_item: '删除商品',
};

export function printTransfer(transfer, details, logs = []) {
  const totalQty = details.reduce((s, i) => s + i.quantity, 0);
  const totalAmt = details.reduce((s, i) => s + parseFloat(i.total_amount), 0);

  const html = `<!DOCTYPE html>
<html><head>
  <meta charset="utf-8">
  <title>调货单 ${transfer.transfer_no}</title>
  <style>
    * { margin:0;padding:0;box-sizing:border-box; }
    body { font-family:'PingFang SC',Arial,sans-serif;font-size:13px;color:#000;padding:20px; }
    .header { text-align:center;margin-bottom:16px; }
    .header h1 { font-size:20px;font-weight:bold;margin-bottom:4px; }
    .header p { font-size:12px;color:#666; }
    .info-grid { display:grid;grid-template-columns:1fr 1fr;gap:6px;margin-bottom:16px;padding:10px;border:1px solid #ddd;border-radius:4px; }
    .info-item { font-size:12px; }
    .info-label { color:#666; }
    .badge { display:inline-block;padding:2px 8px;border-radius:10px;font-size:11px;font-weight:bold;background:#fef3c7;color:#92400e;margin-left:4px; }
    table { width:100%;border-collapse:collapse;margin-bottom:16px; }
    th { background:#f5f5f5;padding:7px 8px;text-align:left;font-size:12px;border:1px solid #ddd; }
    td { padding:7px 8px;border:1px solid #ddd;font-size:12px; }
    .tr { text-align:right; }
    .total-row { font-weight:bold;background:#f9f9f9; }
    .section-title { font-size:13px;font-weight:bold;margin-bottom:8px;padding-bottom:4px;border-bottom:1px solid #eee; }
    .notes { padding:8px;background:#f9f9f9;border:1px solid #eee;border-radius:4px;font-size:12px;margin-bottom:16px;min-height:36px; }
    .log-item { padding:5px 0;border-bottom:1px solid #f0f0f0;font-size:12px; }
    .log-item:last-child { border-bottom:none; }
    .logs-box { border:1px solid #eee;border-radius:4px;padding:8px;margin-bottom:16px; }
    .sign-grid { display:grid;grid-template-columns:1fr 1fr 1fr;gap:16px;margin-top:16px; }
    .sign-box { border:1px solid #ddd;border-radius:4px;padding:10px; }
    .sign-label { font-size:11px;color:#666;margin-bottom:24px; }
    .sign-line { border-top:1px solid #000;margin-top:8px;padding-top:4px;font-size:11px;color:#999;text-align:center; }
    .footer { text-align:center;font-size:11px;color:#999;margin-top:16px;padding-top:8px;border-top:1px solid #eee; }
    @media print { body { padding:10px; } @page { margin:10mm; } }
  </style>
</head>
<body>
  <div class="header"><h1>库存调货单</h1><p>${transfer.transfer_no}</p></div>
  <div class="info-grid">
    <div class="info-item"><span class="info-label">发货方：</span>${transfer.from_store_name || '-'}</div>
    <div class="info-item"><span class="info-label">收货方：</span>${transfer.to_store_name || '-'}</div>
    <div class="info-item"><span class="info-label">申请日期：</span>${new Date(transfer.created_at).toLocaleString('zh-CN')}</div>
    <div class="info-item"><span class="info-label">状态：</span>${STATUS_LABELS[transfer.status] || transfer.status}${transfer.is_modified == 1 ? '<span class="badge">已修改</span>' : ''}</div>
    ${transfer.completed_at ? `<div class="info-item"><span class="info-label">完成日期：</span>${new Date(transfer.completed_at).toLocaleString('zh-CN')}</div>` : ''}
    ${transfer.paid_amount > 0 ? `<div class="info-item"><span class="info-label">付款金额：</span>$${parseFloat(transfer.paid_amount).toFixed(2)}</div>` : ''}
  </div>
  <p class="section-title">商品明细</p>
  <table>
    <thead><tr><th>#</th><th>商品名称</th><th class="tr">调货单位</th><th class="tr">数量（个）</th><th class="tr">成本价</th><th class="tr">小计</th></tr></thead>
    <tbody>${details.map((item, idx) => `<tr>
      <td>${idx + 1}</td><td>${item.product_name}</td>
      <td class="tr">${item.transfer_unit === 'box' && item.box_count ? item.box_count + ' 箱' : item.quantity + ' 个'}</td>
      <td class="tr">${item.quantity} 个</td>
      <td class="tr">$${parseFloat(item.cost_price).toFixed(2)}</td>
      <td class="tr">$${parseFloat(item.total_amount).toFixed(2)}</td>
    </tr>`).join('')}</tbody>
    <tfoot><tr class="total-row"><td colspan="3" class="tr">合计</td><td class="tr">${totalQty} 个</td><td></td><td class="tr">$${totalAmt.toFixed(2)}</td></tr></tfoot>
  </table>
  <p class="section-title">备注</p>
  <div class="notes">${transfer.notes || '（无备注）'}</div>
  ${logs.length > 0 ? `<p class="section-title">修改记录</p>
  <div class="logs-box">${logs.map(log => `<div class="log-item">
    <span style="color:#666">${new Date(log.created_at).toLocaleString('zh-CN')}</span>
    <span style="margin:0 6px;font-weight:bold">${log.operator_name || '-'}</span>
    <span>${LOG_ACTION_MAP[log.action] || log.action}</span>
    ${log.product_name ? `「${log.product_name}」` : ''}
    ${log.old_value ? `<span style="text-decoration:line-through;color:#999;margin-left:4px">${log.old_value}</span>` : ''}
    ${log.new_value ? `<span style="color:#16a34a;margin-left:4px">→ ${log.new_value}</span>` : ''}
  </div>`).join('')}</div>` : ''}
  <div class="sign-grid">
    <div class="sign-box"><div class="sign-label">发货方确认</div><div class="sign-line">签名 / 日期</div></div>
    <div class="sign-box"><div class="sign-label">收货方确认</div><div class="sign-line">签名 / 日期</div></div>
    <div class="sign-box"><div class="sign-label">财务确认</div><div class="sign-line">签名 / 日期</div></div>
  </div>
  <div class="footer">打印时间：${new Date().toLocaleString('zh-CN')}</div>
  <script>window.onload=function(){window.print();window.onafterprint=function(){window.close();}}</script>
</body></html>`;

  const win = window.open('', '_blank', 'width=800,height=900');
  win.document.write(html);
  win.document.close();
}
